"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FooterSocialLinks_1 = __importDefault(require("./FooterSocialLinks"));
exports.default = FooterSocialLinks_1.default;
